import apiSlice from '../api/api.slice';
import { HistoryTarget, PostActivityEntry } from './postActivity.types';

const HISTORY_PATH: Record<HistoryTarget['kind'], string> = {
  post: 'posts',
  projectGroup: 'project-groups',
};

const postActivityApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['PostActivity'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPostActivity: builder.query<
        PostActivityEntry[],
        { target: HistoryTarget; token: string }
      >({
        query: ({ target, token }) => ({
          url: `/api/v1/postActivity/${HISTORY_PATH[target.kind]}/${target.id}?token=${token}`,
          method: 'GET',
        }),
        transformResponse: (response: { activity: PostActivityEntry[] }) =>
          response.activity,
        providesTags: ['PostActivity'],
      }),
    }),
  });

export const { useGetPostActivityQuery } = postActivityApiSlice;
